// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"36":"24d3c48c","215":"823f7989","359":"75d4eddb","434":"eab57d30","495":"8515b3a3","529":"37142433","631":"dc81d7b5","754":"ac3c1fba","766":"37142433"}[chunkId] + ".chunk.css";
};